const reports = {
  en: {
    title: "Report",
    list: {
      title: "Reports",
      table: {
        report_name: "Report Name",
        created_at: "Date",
        created_user: "User",
        total_attacks: "Attack | Attacks",
        total_abilities: "Ability | Abilities",
        status: "Status",
        waiting: "Waiting",
        failed: "Failed"
      },
      buttons: {
        new: "Create New Report"
      }
    },
    newRequesterReportTitle: "New Requester Report",
    newRequesterReportDescription:
      "Fill in the fields on the side, defining the name you wish to receive for the report, the period of time to bring the attacks carried out during the desired period, and other parameters such as: number of skills that ran in the attacks, percentage of skills as success, and system operational area in which the attacks were carried out. It is also possible to define whether the project includes mitigation and the heat map at the end of the report that will be generated by the platform.",
    reportNameLabel: "Report Name",
    reportNamePlaceholder: "Insert your report name",
    reportDateLabel: "Date",
    reportTotalAbilitiesLabel: "Total Abilities",
    reportTotalAbilitiesPlaceholder: "Enter total skills",
    reportSuccessfulAbilitiesLabel: "Successful Abilities",
    reportOperationsSystemsLabel: "Operations Systems",
    reportShowMitigationLabel: "Show Mitigation/Detection",
    reportShowHeatmapLabel: "Show Heat Map",
    buttons: {
      findAttacks: "Find Attacks",
      reviewSelection: "Review Selection",
      conclusionSetup: "Conclusion Setup",
      generateReport: "Generate Report"
    },
    reportParameters: "Report Parameters",
    fromDate: "From",
    toDate: "To",
    operationalSystem: "Operational System",
    redirectStep2Title: "No attacks available",
    redirectStep2Description:
      "You have excluded all available attacks using the predefined parameters. We will direct you to select new available attacks.",
    noneOperator: "None",
    showOperationScroll: "Show >",
    selectedAttacks: "Selected Attacks",
    reportConclusion: "Conclusion",
    executiveSummary: "Executive Summary",
    executiveSummaryTextareaLabel: "Write your text of opening",
    finalConsideration: "Final Consideration",
    finalConsiderationTextareaLabel: "Write your considerations finale",
    titleDayMonday: "Se",
    titleDayTuesday: "Tu",
    titleDayWednesday: "We",
    titleDayThursday: "Th",
    titleDayFriday: "Fr",
    titleDaySaturday: "Sa",
    titleDaySunday: "Su",
    modalCreate: {
      title: "Request Report",
      text: "Are your parameters and attacks all according the report you want to request the generation?"
    },
    modalRemove: {
      title: "Remove Report | Remove Reports",
      text: "You're removing {qty} report(s) from your list, are you sure you want to continue?"
    },
    stepTitle: {
      2: "Attack Selection",
      3: "Attack Order",
      4: "Conclusion Setup"
    },
    operationTable: {
      attack_name: "Attack Name",
      adversary_name: "Adversary/Ability",
      operation_date: "Data",
      agent_name: "Agent",
      agent_so: "OS",
      qty_abilities: "Abilities",
      success_percent: "Attack %"
    }
  },
  pt: {
    title: "Relatório",
    list: {
      title: "Relatórios",
      table: {
        report_name: "Nome do Relatório",
        created_at: "Data",
        created_user: "Usuário",
        total_attacks: "Ataque | Ataques",
        total_abilities: "Habilidade | Habilidades",
        status: "Estado",
        waiting: "Aguardando",
        failed: "Falhou"
      },
      buttons: {
        new: "Criar Novo Relatório"
      }
    },
    newRequesterReportTitle: "Nova Solicitação de Relatório",
    newRequesterReportDescription:
      "Preencha os campos ao lado, definindo o nome que deseja atribuir ao relatório, o período de tempo para trazer os ataques realizados durante o período desejado, e outros parâmetros como: quantidade de habilidades que rodaram nos ataques, percentual de habilidades como sucesso, e sistema operacional em que os ataques foram realizados. É possível também definir se desaja incluir a mitigação e o mapa de calor ao final do relatório que será gerado pela plataforma.",
    reportNameLabel: "Nome do Relatório",
    reportNamePlaceholder: "Insira o nome do relatório",
    reportDateLabel: "Data",
    reportTotalAbilitiesLabel: "Total de Habilidades",
    reportTotalAbilitiesPlaceholder: "Insira o total de habilidades",
    reportSuccessfulAbilitiesLabel: "Habilidades com Sucesso",
    reportOperationsSystemsLabel: "Sistemas Operacionais",
    reportShowMitigationLabel: "Mostrar Mitigação/Detecção",
    reportShowHeatmapLabel: "Mostrar Mapa de Ocorrências",
    buttons: {
      findAttacks: "Procurar Ataques",
      reviewSelection: "Revisar Selecionados",
      conclusionSetup: "Concluir Configuração",
      generateReport: "Gerar Relatório"
    },
    reportParameters: "Parâmetros do Relatório",
    fromDate: "De",
    toDate: "Até",
    operationalSystem: "Sistema Operacional",
    redirectStep2Title: "Sem ataques disponíveis",
    redirectStep2Description:
      "Você excluiu todos os ataques disponíveis utilizando os parâmetros pré-definidos. Vamos te direcionar para selecionar novos ataques disponíveis.",
    noneOperator: "Nenhum",
    showOperationScroll: "Mostrar >",
    selectedAttacks: "Ataques Selecionados",
    reportConclusion: "Conclusão",
    executiveSummary: "Sumário Executivo",
    executiveSummaryTextareaLabel: "Escreva seu texto de abertura",
    titleDayMonday: "Seg",
    titleDayTuesday: "Ter",
    titleDayWednesday: "Qua",
    titleDayThursday: "Qui",
    titleDayFriday: "Sex",
    titleDaySaturday: "Sáb",
    titleDaySunday: "Dom",
    finalConsideration: "Consideração Final",
    finalConsiderationTextareaLabel: "Escreva suas considerações finais",
    modalCreate: {
      title: "Solicitar Relatório",
      text: "Seus parâmetros e ataques estão todos de acordo com o relatório que você deseja solicitar a geração?"
    },
    modalRemove: {
      title: "Remover Relatório | Remover Relatórios",
      text: "Você está removendo {qty} relatório(s) da sua lista, tem certeza de que deseja continuar?"
    },
    stepTitle: {
      2: "Seleção de Ataques",
      3: "Ordem dos Ataques",
      4: "Conclusão da Configuração"
    },
    operationTable: {
      attack_name: "Nome do Ataque",
      adversary_name: "Adversário/Habilidade",
      operation_date: "Data",
      agent_name: "Agente",
      agent_so: "SO",
      qty_abilities: "Habilidades",
      success_percent: "Ataque %"
    }
  },
  es: {
    title: "Informe",
    list: {
      title: "Informes",
      table: {
        report_name: "Nombre del Informe",
        created_at: "Fecha del Informe",
        created_user: "Usuario",
        total_attacks: "Ataque | Ataques",
        total_abilities: "Habilidade | Habilidades",
        status: "Estado",
        waiting: "En espera",
        failed: "Falhou"
      },
      buttons: {
        new: "Crear Nuevo Informe"
      }
    },
    newRequesterReportTitle: "Nuevo informe de solicitud",
    newRequesterReportDescription:
      "Complete los campos al costado, definiendo el nombre que desea recibir para el informe, el período de tiempo para traer los ataques realizados durante el período deseado, y otros parámetros como: número de habilidades que se ejecutaron en los ataques, porcentaje de habilidades como éxito, y área operativa del sistema en la que se llevaron a cabo los ataques. También es posible definir si el proyecto incluye mitigación y el mapa de calor al final del informe que generará la plataforma.",
    reportNameLabel: "Reportar nombre",
    reportNamePlaceholder: "Inserte el nombre de su informe",
    reportDateLabel: "Fecha",
    reportTotalAbilitiesLabel: "Habilidades totales",
    reportTotalAbilitiesPlaceholder: "Ingrese las habilidades totales",
    reportSuccessfulAbilitiesLabel: "Habilidades exitosas",
    reportOperationsSystemsLabel: "Sistemas de operaciones",
    reportShowMitigationLabel: "Mostrar mitigación/detección",
    reportShowHeatmapLabel: "Mostrar mapa de visitas",
    buttons: {
      findAttacks: "Búsqueda de ataques",
      reviewSelection: "Revisar seleccionado",
      conclusionSetup: "Configuración completa",
      generateReport: "Generar informe"
    },
    reportParameters: "Parámetros del Informe",
    fromDate: "Desde",
    toDate: "A",
    operationalSystem: "Sistema Operativo",
    redirectStep2Title: "No hay ataques disponibles",
    redirectStep2Description:
      "Ha excluido todos los ataques disponibles utilizando los parámetros predefinidos. Le indicaremos que seleccione nuevos ataques disponibles.",
    noneOperator: "Ninguno",
    showOperationScroll: "Exhibir >",
    selectedAttacks: "Ataques seleccionados",
    reportConclusion: "Conclusión",
    executiveSummary: "Resumen ejecutivo",
    executiveSummaryTextareaLabel: "Escriba su texto de apertura",
    titleDayMonday: "Lu",
    titleDayTuesday: "Ma",
    titleDayWednesday: "Mi",
    titleDayThursday: "Ju",
    titleDayFriday: "Vi",
    titleDaySaturday: "Sá",
    titleDaySunday: "Do",
    finalConsideration: "Consideracion Finale",
    finalConsiderationTextareaLabel: "Escriba sus reflexiones finales",
    modalCreate: {
      title: "Solicitar Informe",
      text: "¿Son sus parámetros y ataques todos de acuerdo con el informe que desea solicitar la generación?"
    },
    modalRemove: {
      title: "Eliminar Informe | Eliminar Informes",
      text: "Estás eliminando {qty} informe(s) de su lista, ¿está seguro de que desea continuar?"
    },
    stepTitle: {
      2: "Selección de Ataques",
      3: "Orden de los Ataques",
      4: "Finalización de la Configuración"
    },
    operationTable: {
      attack_name: "Nombre del Ataque",
      adversary_name: "Oponente/Habilidade",
      operation_date: "Fecha",
      agent_name: "Agente",
      agent_so: "OS",
      qty_abilities: "Habilidades",
      success_percent: "Ataque %"
    }
  }
}

export default reports
